module.exports = __webpack_public_path__ + "img/Picture29.ff4ea6d0.png";